export default "__VITE_ASSET__BTeJCIjr__"